import authFetch from './fetch';
import qs from 'qs';
import { getQueryParams, makeRequest } from './utils';
import { useQuery } from '@tanstack/react-query';
import { CacheConfig } from './consts';

export const getContactTypes = async (ids) => {
  try {
    const response = await authFetch.get(`/api/CustomerContactTypes${ids ? `IDs=${ids}` : ''}`);
    return Promise.resolve(response.data);
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

export const getContactTypesGrid = async (params) => {
  try {
    const response = await authFetch.get(`/api/CustomerContactTypes/Grid${getQueryParams(params)}`);
    return Promise.resolve(response.data);
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

export const getCustomerContactTypeAudits = async (id, params) => {
  try {
    const response = await authFetch.get(`/api/CustomerContactTypes/${id}/Audits${getQueryParams(params)}`);
    return Promise.resolve(response.data);
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

export const putContactType = async (contactType) => {
  try {
    const response = await authFetch.put('/api/CustomerContactTypes', contactType);
    return Promise.resolve(response.data);
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

export const deleteContactType = async (id) => {
  try {
    const response = await authFetch.delete(`/api/CustomerContactTypes/${id}`);
    return Promise.resolve(response.data);
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

export const patchContactType = async (id) => {
  try {
    const response = await authFetch.patch(`/api/CustomerContactTypes/${id}/restore`);
    return Promise.resolve(response.data);
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

export const getShipLines = async () => {
  try {
    const response = await authFetch.get('/api/ShipLines');
    return Promise.resolve(response.data);
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

export const getCarrierTerminals = async (params) => {
  try {
    const response = await authFetch.get(`/api/CarrierTerminals${getQueryParams(params)}`);
    return Promise.resolve(response.data);
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

export const getCarrierTerminal = async (id) => {
  try {
    const response = await authFetch.get(`/api/CarrierTerminals/${id}`);
    return Promise.resolve(response.data);
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

export const putTraceTerminal = async (data) => makeRequest(authFetch.put('/api/CarrierTerminals', data));

export const getCarrierTerminalTypes = async () => {
  try {
    const response = await authFetch.get('/api/CarrierTerminals/TerminalTypes');
    return Promise.resolve(response.data);
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

export const getWarehouses = async () => {
  try {
    const response = await authFetch.get('/api/CMSv2/Warehouses');
    return Promise.resolve(response.data);
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

export const getWarehousesLocations = async () => {
  try {
    const response = await authFetch.get('/api/CMSv2/Warehouses/lookups');
    return Promise.resolve(response.data);
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

export const getCustomers = async (name) => {
  try {
    const response = await authFetch.get(`api/customers?IsDeleted=false&Name=${name || ''}`);
    return Promise.resolve(response.data);
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

export const getBillTos = async (name) => {
  try {
    const response = await authFetch.get(`api/customers/billtos?IsDeleted=false&Name=${name || ''}`);
    return Promise.resolve(response.data);
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

export const getNoteTemplates = async (search) => makeRequest(authFetch.get(`/api/NoteTemplates${getQueryParams(search)}`));
export const getNoteTemplatesLookups = async () => makeRequest(authFetch.get('/api/NoteTemplates/Lookups'));
export const upsertNoteTemplate = async (template) => makeRequest(authFetch.put('/api/NoteTemplates', template));
export const deleteNoteTemplate = async (id) => makeRequest(authFetch.delete(`/api/NoteTemplates/${id}`));
export const restoreNoteTemplate = async (id) => makeRequest(authFetch.patch(`/api/NoteTemplates/${id}/Restore`));
export const getNoteTemplate = async (id) => makeRequest(authFetch.get(`/api/NoteTemplates/${id}`));
export const getNoteTemplatesAudits = (id, params) => makeRequest(authFetch.get(`/api/NoteTemplates/${id}/Audits${getQueryParams(params)}`));
export const getNoteTemplatesAuditProperties = (id) => makeRequest(authFetch.get(`/api/NoteTemplates/${id}/Audits/Properties`));
export const getNoteTemplatesAuditUsers = (id) => makeRequest(authFetch.get(`/api/NoteTemplates/${id}/Audits/Users`));

export const getNoteTemplateTypes = async () => {
  try {
    const response = await authFetch.get('/api/NoteTemplates/Types');
    return Promise.resolve(response.data);
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

export const getCompanyInfo = async () => {
  try {
    const response = await authFetch.get('/api/CompanyInfo');
    return Promise.resolve(response.data);
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

export const postCompanyInfo = async (companyInfo) => {
  try {
    const response = await authFetch.post('/api/CompanyInfo', companyInfo);
    return Promise.resolve(response.data);
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

/// DEPRECATED - These should be in users.js - leaving for now for backward compatibility
export const getUsers = async (search) => {
  try {
    const response = await authFetch.get(
      `/api/Users?${search && Object.keys(search).length ? qs.stringify(search) : ''}`,
    );
    return Promise.resolve(response.data);
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

/// DEPRECATED - These should be in users.js - leaving for now for backward compatibility
export const postUser = async (user) => {
  try {
    const response = await authFetch.post('/api/Users', user);
    return Promise.resolve(response.data);
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

export const getCarriersLookup = () => makeRequest(authFetch.get(`${'api/ExternalCarriers/Lookup'}`)).then((data) => data.map((carrier) => ({ value: carrier.id, ...carrier })));
export const useGetCarriersLookup = () => useQuery(['carriersLookup'], getCarriersLookup, CacheConfig.forever);
export const getCarrierTerminalsLookup = () => makeRequest(authFetch.get(`${'api/CarrierTerminals/Lookup'}`)).then((data) => data.map((carrier) => ({ name: carrier.description, ...carrier })));
export const useGetCarrierTerminalsLookup = () => useQuery(['carrierTerminalsLookup'], getCarrierTerminalsLookup, CacheConfig.forever);
export const findCarrierForAddress = (address) => makeRequest(authFetch.get(`${'api/ExternalCarriers/FindForAddress'}${getQueryParams(address)}`));
export const getCarriersGrid = (params) => makeRequest(authFetch.get(`${'api/ExternalCarriers'}${getQueryParams(params)}`));
export const restoreCarrier = (id) => makeRequest(authFetch.patch(`api/ExternalCarriers/${id}/restore`));
export const getCarrierById = (id) => makeRequest(authFetch.get(`api/ExternalCarriers/${id}`));
export const postCarrier = (carrier) => makeRequest(authFetch.put('api/ExternalCarriers', carrier));
export const deleteCarrier = (id) => makeRequest(authFetch.delete(`api/ExternalCarriers/${id}`));
export const getCarriersAudits = (id, params) => makeRequest(authFetch.get(`/api/ExternalCarriers/${id}/Audits${getQueryParams(params)}`));
export const getCarriersAuditProperties = (id) => makeRequest(authFetch.get(`/api/ExternalCarriers/${id}/Audits/Properties`));
export const getCarriersAuditUsers = (id) => makeRequest(authFetch.get(`/api/ExternalCarriers/${id}/Audits/Users`));

export const getCarriersGridSearchProperties = () => makeRequest(authFetch.get('/api/ExternalCarriers/SearchProperties'));
export const useGetCarriersGridSearchProperties = () => useQuery(
  ['carriersGridSearchProperties'], getCarriersGridSearchProperties, CacheConfig.forever,
);

export const getCarrierRatesGrid = (params) => makeRequest(authFetch.get(`${'api/ExternalCarriers/Rates'}${getQueryParams(params)}`));
export const getCarrierRateById = (id) => makeRequest(authFetch.get(`api/ExternalCarriers/Rates/${id}`));
export const postCarrierRate = (carrier) => makeRequest(authFetch.put('api/ExternalCarriers/Rates', carrier));
export const deleteCarrierRate = (id) => makeRequest(authFetch.delete(`api/ExternalCarriers/Rates/${id}`));
export const deleteCarrierTerminal = (id) => makeRequest(authFetch.delete(`api/CarrierTerminals/${id}`));
export const restoreCarrierTerminal = (id) => makeRequest(authFetch.patch(`api/CarrierTerminals/${id}/restore`));
export const restoreCarrierRate = (id) => makeRequest(authFetch.patch(`api/ExternalCarriers//Rates/${id}/restore`));
export const getCarrierRatesAudits = (id, params) => makeRequest(authFetch.get(`/api/ExternalCarriers/Rates/${id}/Audits${getQueryParams(params)}`));
export const getCarrierRatesAuditProperties = (id) => makeRequest(authFetch.get(`/api/ExternalCarriers/Rates/${id}/Audits/Properties`));
export const getCarrierRatesAuditUsers = (id) => makeRequest(authFetch.get(`/api/ExternalCarriers/Rates/${id}/Audits/Users`));

export const getCarrierTerminalsAudits = (id, params) => makeRequest(authFetch.get(`/api/CarrierTerminals/${id}/Audits${getQueryParams(params)}`));
export const getCarrierTerminalsAuditProperties = (id) => makeRequest(authFetch.get(`/api/CarrierTerminals/${id}/Audits/Properties`));
export const getCarrierTerminalsAuditUsers = (id) => makeRequest(authFetch.get(`/api/CarrierTerminals/${id}/Audits/Users`));

export const getCustomerFSCTypes = () => makeRequest(authFetch.get('/api/Quotes/CustomerFSCTypes'));

export const getGroupToRoleMappings = () => makeRequest(authFetch.get('/api/GroupToRoleMappings'));
export const updateGroupToRoleMapping = (data) => makeRequest(authFetch.put('/api/GroupToRoleMappings', data));

export const getScacEmptyLocations = (params) => makeRequest(authFetch.get(`api/ScacEmptyLocation${getQueryParams(params)}`));
export const updateScacEmptyLocation = (location) => makeRequest(authFetch.put('api/ScacEmptyLocation', location));
export const deleteScacEmptyLocation = (id) => makeRequest(authFetch.delete(`api/ScacEmptyLocation/${id}`));
export const restoreScacEmptyLocation = (id) => makeRequest(authFetch.patch(`api/ScacEmptyLocation/${id}/restore`));

export const getRoles = (params) => makeRequest(authFetch.get(`api/roles${getQueryParams(params)}`));
export const getRole = (id) => makeRequest(authFetch.get(`api/roles/${id}`));
export const getPrivileges = () => makeRequest(authFetch.get('api/roles/privileges'));
export const upsertRole = (data) => makeRequest(authFetch.put('api/roles/', data));
export const getRolesLookup = () => makeRequest(authFetch.get('api/roles/lookup'));
export const getRolesWithCustomDataLookup = () => makeRequest(authFetch.get('api/roles/lookup/withCustom'));
export const restoreRole = (id) => makeRequest(authFetch.patch(`api/roles/${id}/restore`));
export const deleteRole = (id) => makeRequest(authFetch.delete(`api/roles/${id}`));
export const getRoleAudits = (id, params) => makeRequest(authFetch.get(`/api/roles/${id}/Audits${getQueryParams(params)}`));
export const getRoleAuditProperties = (id) => makeRequest(authFetch.get(`/api/roles/${id}/Audits/Properties`));
export const getRoleAuditUsers = (id) => makeRequest(authFetch.get(`/api/roles/${id}/Audits/Users`));

export const getRescheduleReasons = (params) => makeRequest(authFetch.get(`api/RescheduleReasons${getQueryParams(params)}`));
export const getRescheduleReason = (id) => makeRequest(authFetch.get(`api/RescheduleReasons/${id}`));
export const restoreRescheduleReason = (id) => makeRequest(authFetch.patch(`api/RescheduleReasons/${id}/restore`));
export const deleteRescheduleReason = (id) => makeRequest(authFetch.delete(`api/RescheduleReasons/${id}`));
export const upsertRescheduleReason = (data) => makeRequest(authFetch.put('api/RescheduleReasons/', data));
export const getRescheduleReasonAudits = (id, params) => makeRequest(authFetch.get(`/api/RescheduleReasons/${id}/Audits${getQueryParams(params)}`));
export const getRescheduleReasonAuditProperties = (id) => makeRequest(authFetch.get(`/api/RescheduleReasons/${id}/Audits/Properties`));
export const getRescheduleReasonAuditUsers = (id) => makeRequest(authFetch.get(`/api/RescheduleReasons/${id}/Audits/Users`));

export const getDeclineDispatchReasons = (params) => makeRequest(authFetch.get(`api/DeclineDispatchReasons${getQueryParams(params)}`));
export const getDeclineDispatchReason = (id) => makeRequest(authFetch.get(`api/DeclineDispatchReasons/${id}`));
export const restoreDeclineDispatchReason = (id) => makeRequest(authFetch.patch(`api/DeclineDispatchReasons/${id}/restore`));
export const deleteDeclineDispatchReason = (id) => makeRequest(authFetch.delete(`api/DeclineDispatchReasons/${id}`));
export const upsertDeclineDispatchReason = (data) => makeRequest(authFetch.put('api/DeclineDispatchReasons/', data));
export const getDeclineDispatchReasonAudits = (id, params) => makeRequest(authFetch.get(`/api/DeclineDispatchReasons/${id}/Audits${getQueryParams(params)}`));
export const getDeclineDispatchReasonAuditProperties = (id) => makeRequest(authFetch.get(`/api/DeclineDispatchReasons/${id}/Audits/Properties`));
export const getDeclineDispatchReasonAuditUsers = (id) => makeRequest(authFetch.get(`/api/DeclineDispatchReasons/${id}/Audits/Users`));


// scaffolding dashboard
export const scaffoldingDashboardNotMappedOrganizations = (params) => makeRequest(authFetch.get(`/api/ScaffoldingDashboard/NotMappedOrganizations${getQueryParams(params)}`));